module.exports = __webpack_public_path__ + "roundabout_slight_left.svg?ade85425fa54405938cdac5e32d281f8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/roundabout_slight_left.svg
// module id = 220
// module chunks = 0